import { AfterViewInit, Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'pq-reset-password',
    templateUrl: './reset-password.component.html',
    standalone: false
})
export class ResetPasswordComponent implements OnInit, AfterViewInit {
  loading: boolean = true;
  disabled: boolean = false;
  passwordMinLength = environment.passwordMinLength;
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    public router: Router,
    private readonly messageService: MessageService,
    private activatedRoute: ActivatedRoute
  ) {}
  form!: FormGroup;
  loggedIn = false;
  private token!: string;

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.queryParams['token'];
    this.form = this.formBuilder.group(
      {
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(environment.passwordMinLength),
            Validators.maxLength(20),
            Validators.pattern(
              new RegExp(`(?=^.{${environment.passwordMinLength},20}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$`)
            ),
          ],
        ],
        confirm: ['', Validators.required],
      },
      { validators: this.passwordMatchValidator, updateOn: 'blur' }
    );
    this.loading = false;
  }
  ngAfterViewInit() {
    const decodedToken = this.authService.readToken(this.token);
    if (new Date(decodedToken.exp * 1000) < new Date()) {
      this.disabled = true;
      const message = {
        severity: 'error',
        summary: 'Expired link',
        life: 5000,
        key: 'expired',
        detail: 'Your link has expired.  Please request another one.',
      };
      this.messageService.add(message);
    }
  }
  resetPassword(): void {
    this.loading = true;
    this.authService
      .resetPassword(this.form.get('password')?.value, this.token)
      .subscribe({
        next: (resp) => {
          this.loading = false;
          this.form.get('password')?.disable();
          this.form.get('confirm')?.disable();
          this.messageService.add({
            severity: 'success',
            life: 5000,
            key: 'success',
            summary: 'Password Change',
            detail: 'Password successfully changed',
          });
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            life: 5000,
            key: 'error',
            summary: 'Password Change Error',
            detail: 'Error changing password',
          });
          this.loading = false;
        },
      });
  }
  private passwordMatchValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const password = control.get('password');
    const confirm = control.get('confirm');

    return password && confirm && password.value === confirm.value
      ? null
      : { passwordNotMatched: true };
  };
}
